export const LANGUAGES_COLUMN_TRANSITIONS_SPRING_PROPS = Object.freeze({
    from: {
        transform: 'translate3d(0, 50%, 0)'
    },
    enter: {
        transform: 'translate3d(0, 0, 0)'
    }
});
